import { CommonModule } from "@angular/common";
import { Component, inject, input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { IComputedConversation } from "@app/shared/chat/interfaces/conversation.interface";
import { ChatService } from "@app/shared/chat/services/chat.service";
import { Skeleton } from "primeng/skeleton";
import { ChatSocketService } from "@app/shared/chat/services/chat-socket.service";
import { IChatMessage } from "@app/shared/chat/interfaces/chat-message.interface";

@Component({
  selector: "app-conversations-list",
  imports: [CommonModule, TranslateModule, Skeleton],
  templateUrl: "./conversations-list.component.html",
  styleUrl: "./conversations-list.component.scss",
})
export class ConversationsListComponent implements OnInit {
  router = inject(Router);
  chatService = inject(ChatService);
  chatSocketService = inject(ChatSocketService);

  activeConversationId = input<string>();

  loading = true;

  ngOnInit() {
    this.chatService.loadConversation().subscribe({
      complete: () => (this.loading = false),
    });
    this.chatSocketService.messageSent$.subscribe({
      next: data => this.handleOutgoingMessage(data),
    });
  }

  handleOutgoingMessage(data: { conversationId: string; message: IChatMessage }) {
    if (
      data.conversationId === this.activeConversationId() &&
      this.chatService.conversations()?.[0].counterpartSwapRequest.id === data.conversationId
    ) {
      return this.chatService.updateConversation(this.chatService.conversations()?.[0].id, { lastMessage: { ...data.message, isSeen: true } });
    }
    this.chatService.loadConversation(false, true).subscribe();
  }

  openConversation(conversation: IComputedConversation) {
    return this.chatService.openConversation(conversation);
  }

  navigateToList() {
    this.router.navigate(["/"]);
  }
}
